export const API_LIST = {
  UPDATE_USER: '/api/user_profile/update',
  CHANGE_PASSWORD: '/api/user_profile/change-password',
  DETAIL_USER: '/api/user_profile/detail',
};
